import { useTranslation } from 'react-i18next'

import { Status } from '../../../Status'

import { getCalendarItemCardTags } from './CalendarItemCardTags.utils'

import * as styles from './CalendarItemCardTags.module.css'

function CalendarItemCardTags({ isArchived, isDue, kind }) {
  const { t } = useTranslation()

  return (
    <div className={styles.CalendarItemCardTags}>
      {getCalendarItemCardTags({ isArchived, isDue, kind }).map(tag => (
        <Status {...tag} key={tag.text} text={t(tag.text)} />
      ))}
    </div>
  )
}

export default CalendarItemCardTags
